import { API } from "aws-amplify";

export default async function getTempCustomPayments() {
  return await API.get("customPayment", "temp__get_custom_payment_data");
}
